import { ClipboardCheck } from 'lucide-react';
import type { FeatureModule } from '../../app/feature-module';
import { AprovacoesPage } from './pages/AprovacoesPage';
import { AprovacaoDetailPage } from './pages/AprovacaoDetailPage';

export const aprovacoesModule: FeatureModule = {
  id: 'aprovacoes',
  label: 'Aprovações',
  icon: ClipboardCheck,
  basePath: '/aprovacoes',
  routes: [
    { path: '/', element: <AprovacoesPage /> },
    { path: '/:id', element: <AprovacaoDetailPage /> },
  ],
  sidebarSection: 'workspace',
  requiredPermission: 'proposals.manage',
};
